import { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Divider, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { getMapLabelByOperationType } from '../constants/singleFlow';
import type { OperationTypes } from '../constants/singleFlow.js';

type Props = {
  variant: OperationTypes;
};

const Separator: FC<Props> = ({ variant }) => {
  const { t } = useTranslation('@myn/approval_v2');
  const mapLabelByOperationType = getMapLabelByOperationType(t);

  return (
    <div className="flex items-center gap-2">
      <div className="grow">
        <Divider orientation="horizontal" />
      </div>
      <span
        className={cn(
          typographyVariants({
            variant: 'bodyShort01',
            color: 'secondary',
          }),
          'shrink-0 uppercase',
        )}
      >
        {mapLabelByOperationType[variant]}
      </span>
      <div className="grow">
        <Divider orientation="horizontal" />
      </div>
    </div>
  );
};

export default Separator;
